import headerLogoIcon from '../../../assets/header-logo.svg';
import { theme } from '../../../theme';
import { StepContextInterface } from './types';

export const defaultStepContext: StepContextInterface = {
  agentChatIcon: headerLogoIcon,
  areLoadingDotsVisible: false,
  confirmTag: () => {},
  customConfigParams: {},
  enabled_feature_flags: [],
  error: null,
  isAutonomousAgent: false,
  isMobile: false,
  liveChatAgentChatIcon: '',
  loading: false,
  messageBubblePositions: null,
  messageDelays: [],
  mode: 'workflow',
  openArticleInWidget: () => {},
  sendTrackingEvent: () => {},
  setTouchedFormFields: () => {},
  size: 'standard',
  startNewIntentSelection: () => {},
  streaming: false,
  themeColor: theme.palette.primary.main,
  touchedFormFields: [],
  updateConversation: () => {},
  widgetComponents: [],
  workflowsConfig: null,
};
